import { Box, type SxProps, type Theme } from '@mui/material';
import { iconMap, type IconName } from './icon-map';

interface IconProps {
  name: IconName;
  size?: number;
  alt?: string;
  sx?: SxProps<Theme>;
}

export const Icon = ({ name, size = 80, alt = '', sx }: IconProps) => {
  const src = iconMap[name];

  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        ...sx,
      }}
    />
  );
};
